import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["columnConfig"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import produce from 'immer';
import _find from 'lodash/find';
import _noop from 'lodash/noop';
import _curry from 'lodash/curry';
import _head from 'lodash/head';
import _set from 'lodash/set';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Builders
import ColumnConfig from '../../builders/ColumnConfig';
import CellConfig from '../../builders/CellConfig';
var DEFAULT_COLUMN_CONFIG = new ColumnConfig();
var DEFAULT_CELL_CONFIG = new CellConfig();
export var getComponentProps = function getComponentProps(cellConfig, props) {
  var mapCellPropsToComponentProps = cellConfig.getMapCellPropsToComponentProps() || _noop;
  var componentProps = mapCellPropsToComponentProps(props);
  return componentProps;
};
var isCellConfigActive = _curry(function (restProps, columnConfig, cellConfig) {
  var shouldRender = cellConfig.getShouldRender() || _noop;
  var shouldRenderCellConfig = shouldRender(_objectSpread(_objectSpread({}, restProps), {}, {
    columnConfig: columnConfig
  }));
  return shouldRenderCellConfig;
});
export var getCellConfigToRender = function getCellConfigToRender(_ref) {
  var _ref$columnConfig = _ref.columnConfig,
    columnConfig = _ref$columnConfig === void 0 ? DEFAULT_COLUMN_CONFIG : _ref$columnConfig,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var cellConfigs = columnConfig.getCellConfigs();
  var activeCellConfig = _find(cellConfigs, isCellConfigActive(restProps, columnConfig)) || _head(cellConfigs);
  return activeCellConfig || DEFAULT_CELL_CONFIG;
};
export var getCellValue = function getCellValue(_ref2) {
  var columnConfig = _ref2.columnConfig,
    rowData = _ref2.rowData,
    rowIndex = _ref2.rowIndex;
  var accessor = columnConfig.getAccessor();
  var cellValue = accessor(rowData, rowIndex);
  return cellValue;
};
export var getCellOnChangeValue = function getCellOnChangeValue(inputParams) {
  var columnConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_COLUMN_CONFIG;
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
  var cellConfig = getCellConfigToRender(_objectSpread({
    columnConfig: columnConfig
  }, props));
  var componentProps = getComponentProps(cellConfig, props);
  var getValueFromOnChange = columnConfig.getGetValueFromOnChange() || _head;
  var cellValue = getValueFromOnChange.apply(void 0, [_objectSpread(_objectSpread({}, props), componentProps)].concat(_toConsumableArray(inputParams)));
  return cellValue;
};
export var getUpdatedRowData = function getUpdatedRowData(_ref3) {
  var inputParams = _ref3.inputParams,
    _ref3$columnConfig = _ref3.columnConfig,
    columnConfig = _ref3$columnConfig === void 0 ? DEFAULT_COLUMN_CONFIG : _ref3$columnConfig,
    rowData = _ref3.rowData,
    props = _ref3.props;
  var columnId = columnConfig.getColumnId();
  var cellValue = getCellOnChangeValue(inputParams, columnConfig, props);
  var updatedRowData = produce(rowData, function (rowVal) {
    return _set(rowVal, columnId, cellValue);
  });
  return updatedRowData;
};